import { Dispatch, SetStateAction, useEffect, useState } from "react";
import MultipleSelect from "../../../components/MultipleSelect/MultipleSelect";
import { ISO639Lang } from "../../../constans/languagesList";
import {
  FlexPassFilteres,
  FlexPassParamsAvailable,
  SubscriptionType,
} from "../../../types/FlexPassTypes";
import { getTranslation } from "../../../utils/getTranslation";
import DateRangeFilter, { DateRange } from "./DateRangeFilter/DateRangeFilter";
import s from "./FlexPassFilters.module.css";

type SelectType = { value: string; lable: string; disabled?: boolean };

type FiltersData = {
  language?: SelectType[];
  mainSpecialization?: SelectType[];
  level?: SelectType[];
  isActive?: SelectType[];
  type?: SelectType[];
};

type FlexPassFiltersProps = {
  setFilters: Dispatch<SetStateAction<FlexPassFilteres>>;
  paramsAvailable: FlexPassParamsAvailable | undefined;
  filters: FlexPassFilteres;
};

const FlexPassFilters = ({
  setFilters,
  paramsAvailable,
  filters,
}: FlexPassFiltersProps) => {
  const [filtersData, setFiltersData] = useState<FiltersData>({});

  useEffect(() => {
    if (!paramsAvailable) return;

    const mainSpecData = paramsAvailable.mainSpecializations.map((item) => ({
      lable: getTranslation(item.value.labels, "en"),
      value: item.value._id,
    }));
    const levelsData = paramsAvailable.levels.map((item) => ({
      lable: getTranslation(item.value.title, "en"),
      value: item.value._id,
    }));
    const langsData = paramsAvailable.languages.map((item) => ({
      lable: ISO639Lang[item.value],
      value: item.value,
    }));
    const isActiveStatusData = [
      {
        value: "active",
        lable: "Active",
      },
      {
        value: "notActive",
        lable: "Not Active",
      },
      {
        value: "all",
        lable: "All",
      },
    ];

    const typeData = [
      {
        value: SubscriptionType.DISCOUNT,
        lable: "Discount on sessions",
      },
      {
        value: SubscriptionType.SESSION_VOLUME,
        lable: "Session volume",
      },
    ];
    setFiltersData({
      language: langsData,
      level: levelsData,
      mainSpecialization: mainSpecData,
      isActive: isActiveStatusData,
      type: typeData,
    });
  }, [paramsAvailable]);

  const activeStatusSelectConverter = {
    active: true,
    notActive: false,
    all: undefined,
  };

  return (
    <div className={s.container}>
      <div style={{ width: "calc(25% - 20px)" }}>
        <DateRangeFilter
          date={filters.startDate}
          setDate={(value: DateRange | undefined) =>
            setFilters((prev) => ({
              ...prev,
              startDate: value
                ? { from: value.startDate, to: value.endDate }
                : value,
              page: 1,
            }))
          }
          label="Start Date"
        />
      </div>
      <div style={{ width: "calc(25% - 20px)" }}>
        <DateRangeFilter
          date={filters.endDate}
          setDate={(value: DateRange | undefined) =>
            setFilters((prev) => ({
              ...prev,
              endDate: value
                ? { from: value.startDate, to: value.endDate }
                : value,
              page: 1,
            }))
          }
          label="End Date"
        />
      </div>
      <MultipleSelect
        data={filtersData.mainSpecialization ?? []}
        multiplie={true}
        setValue={(value) => {
          setFilters((prev) => ({
            ...prev,
            mainSpecialization: value.length ? (value as string[]) : undefined,
            page: 1,
          }));
        }}
        value={filters.mainSpecialization ?? []}
        chip
        checkBox
        lable="Specializations"
        width="calc(25% - 20px)"
      />
      <MultipleSelect
        data={filtersData.level ?? []}
        multiplie={true}
        setValue={(value) => {
          setFilters((prev) => ({
            ...prev,
            level: value.length ? (value as string[]) : undefined,
            page: 1,
          }));
        }}
        value={filters.level ?? []}
        chip
        checkBox
        lable="Levels"
        width="calc(25% - 20px)"
      />
      <MultipleSelect
        data={filtersData.language ?? []}
        multiplie={true}
        setValue={(value) => {
          setFilters((prev) => ({
            ...prev,
            language: value.length ? (value as string[]) : undefined,
            page: 1,
          }));
        }}
        value={filters.language ?? []}
        chip
        checkBox
        lable="Language"
        width="calc(25% - 20px)"
      />
      <MultipleSelect
        data={filtersData.isActive ?? []}
        multiplie={false}
        setValue={(value) => {
          setFilters((prev) => ({
            ...prev,
            isActive:
              activeStatusSelectConverter[
                value as keyof typeof activeStatusSelectConverter
              ],
            page: 1,
          }));
        }}
        value={
          Object.keys(activeStatusSelectConverter).find(
            (key) =>
              activeStatusSelectConverter[
                key as keyof typeof activeStatusSelectConverter
              ] === filters.isActive
          ) ?? ""
        }
        lable="Status"
        width="calc(25% - 20px)"
        disableSortData
      />
      <MultipleSelect
        data={filtersData.type ?? []}
        multiplie={false}
        setValue={(value) => {
          setFilters((prev) => ({
            ...prev,
            type: value as SubscriptionType,
            page: 1,
          }));
        }}
        value={filters.type ?? ""}
        lable="Type"
        width="calc(25% - 20px)"
        disableSortData
      />
    </div>
  );
};

export default FlexPassFilters;
